import React, { Component } from 'react';
import { hot } from 'react-hot-loader';
import { connect } from 'react-redux';
import cartAnalytics from '../Selection/cartAnalytics';
import Button from '../Elements/Button/Button';
import FakeSelect from '../Elements/FakeSelect/FakeSelect';
import { addEvent, removeEvent } from '../../utils/dom';
import { translate } from '../../utils/string';
import { addToBag } from '../../actions/checkout';
import s from './Purchase.scss';

class Purchase extends Component {
	constructor(props) {
		super(props);

		const { sizes } = props;

		this.state = {
			formError: false,
			formErrorHover: false,
			selected: sizes.length === 1 ? sizes[0].item : false,
		};

		this.formElement = React.createRef();
	}

	componentDidMount() {
		addEvent(document.querySelector('body'), 'click.clearFormError', (e) => {
			if (this.formElement.current && !this.formElement.current.contains(e.target) && this.state.formError) {
				e.stopPropagation();
				e.preventDefault();
				this.setState({
					formError: false,
				});
			}
		});

		addEvent(window, 'keydown.clearFormError', (e) => {
			if (e.key === 'Escape') {
				this.setState({
					formError: false,
				});
			}
		});
	}

	componentWillUnmount() {
		removeEvent(document.querySelector('body'), 'click.clearFormError');
		removeEvent(window, 'keydown.clearFormError');
	}

	addToBagHandler = (e) => {
		e.preventDefault();
		const { setup, productCache, productId, originalProduct, currentPath, checkout } = this.props;
		let { selected } = this.state;

		if (selected) {
			const cachedProduct = productCache[setup.market][setup.pricelist].products[productId];
			if (cachedProduct.sizes.length === 1) selected = cachedProduct.sizes[0].item;

			this.props.addToBag(selected, 1, currentPath, cachedProduct).then((response) => {
				const itemObject = response?.selection?.items && response.selection.items.reduce((acc, item) => ({ ...acc, ...(item.item === selected ? item : {}) }), {});
				cartAnalytics(cachedProduct, itemObject, setup, originalProduct, checkout.listItemCache);
				return response;
			}).catch(() => { console.log('DEBUG: add to bag failed'); });
		} else {
			this.setState({
				formError: true,
			});
		}
	}

	selectSizeHandler = (item) => {
		this.setState({
			formError: false,
			selected: item,
		});
	}

	addToBagMouseEnterHandler = () => {
		const { selected } = this.state;

		if (!selected) {
			this.setState({
				formErrorHover: true,
			});
		}
	}

	addToBagMouseLeaveHandler = () => {
		this.setState({
			formErrorHover: false,
		});
	}

	render() {
		const { setup, sizes, checkout, soldOut, instoreOnly = false } = this.props;
		const { formError, formErrorHover, selected } = this.state;
		const formattedSizes = sizes.map((item) => ({
			key: item.item,
			value: item.name,
			disabled: item.stock === 0,
			selected: selected === item.item,
		}));

		let buttonText = formError || formErrorHover ? translate(setup, 'chooseSize') : translate(setup, 'addToBag');
		if (soldOut) buttonText = soldOut;

		if (instoreOnly === '1' || instoreOnly === true) {
			buttonText = translate(setup, 'instoreOnly');

			return (
				<div className={s.purchase}>
					<p className={s.purchase_instoreInfo}>{ translate(setup, 'instoreOnlyInfo') }</p>
					<div className={s.purchase_choice}>
						<FakeSelect open={formError && soldOut === false} disabled={soldOut !== false} items={formattedSizes} title={translate(setup, 'chooseSize')} selectionHandler={this.selectSizeHandler} />
					</div>
					<div className={[s.purchase_submit, s.purchase_submit__instore].join(' ')}>
						<Button disabled text={buttonText} />
					</div>
				</div>
			);
		}

		return (
			<form className={s.purchase} onSubmit={this.addToBagHandler} ref={this.formElement}>
				<div className={s.purchase_choice}>
					<FakeSelect open={formError && soldOut === false} disabled={soldOut !== false} items={formattedSizes} title={translate(setup, 'chooseSize')} selectionHandler={this.selectSizeHandler} />
				</div>
				<div className={s.purchase_submit}>
					<Button disabled={soldOut !== false} text={buttonText} mouseEnterEventHandler={this.addToBagMouseEnterHandler} mouseLeaveEventHandler={this.addToBagMouseLeaveHandler} />
				</div>
				{ checkout.addToBagError ? <div className={s.purchase_error}>{ translate(setup, 'addToBagError') }</div> : null }
			</form>
		);
	}
}

const mapState = ({ checkout, productCache }, { setup, currentPath, sizes, productId }) => ({
	sizes,
	productId,
	currentPath,
	setup,
	checkout,
	productCache,
});

export default hot(module)(connect(mapState, { addToBag })(Purchase));
